import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import React, { cloneElement, Component } from 'react';

import './NewFundContainer.scss';
import { moduleActions } from '../../redux/modules';
import {
  getAddFundList,
  getAvailableFundList,
} from '../../redux/modules/shoppingCart/shoppingCart.selectors';
import { getSelectedBankAssociableOrAssociatedLookup } from '../../redux/modules/bankSelection/bankSelection.selectors';
import {
  getCollegeExchangeToNewFundList,
  getCollegeExchangeRegistrationTypeInfo,
  getExchangeFromFirstFund,
  getExchangeRegistrationTypeInfo,
  getExchangeToFundList,
  getExchangeToNewAvailableFundList,
  getCollegeExchangeToFundList,
} from '../../redux/modules/exchangeTransaction/exchangeTransaction.selectors';
import { getCollegeToNewAvailableFundList } from '../../redux/modules/shoppingCart/collegeShoppingCart.selectors';
import { getRegistrationTypeInfoWithProductTypes } from '../../redux/modules/user/UserRegistrationTypes/UserRegistrationTypes.selectors';
import {
  analyticsDataLayer,
  dispatchPageLoad,
} from '../../redux/utils/analytics-helper';
import {
  isCollegeAnything,
  isCollegeExchange,
  isExchange,
} from '../../utils/transactions-util';

require('animate.css/animate.min.css');

export class NewFundContainer extends Component {
  componentDidMount() {
    const {
      actions: { getRegistrationTypes },
    } = this.props;
    getRegistrationTypes();
  }

  render() {
    const { children, ...rest } = this.props;
    return cloneElement(React.Children.only(children), {
      ...rest,
      analyticsDataLayer,
      dispatchPageLoad,
    });
  }
}

const mapStateToProps = (state) => {
  const {
    authentication,
    exchangeTransaction: { exchangeToNewLoading },
    routing,
    shoppingCart,
    userFunds,
    user,
    userProductTypes,
  } = state;
  const exch = isExchange();
  return {
    addFunds: exch
      ? getExchangeToNewAvailableFundList(state)
      : isCollegeAnything()
      ? isCollegeExchange()
        ? getCollegeExchangeToNewFundList(state)
        : getCollegeToNewAvailableFundList(state)
      : getAddFundList(state),
    authentication,
    availableFundList: exch
      ? getExchangeToFundList(state)
      : isCollegeExchange()
      ? getCollegeExchangeToFundList(state)
      : getAvailableFundList(state),
    exchangeFromFirstFund: getExchangeFromFirstFund(state),
    exchangeToNewLoading,
    routing,
    selectedBankAssociableOrAssociatedLookup:
      getSelectedBankAssociableOrAssociatedLookup(state),
    shoppingCart,
    user,
    userFunds,
    userProductTypes,
    userRegistrationTypeInfo: exch
      ? getExchangeRegistrationTypeInfo(state)
      : isCollegeExchange()
      ? getCollegeExchangeRegistrationTypeInfo(state)
      : getRegistrationTypeInfoWithProductTypes(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    isExchange() || isCollegeExchange()
      ? {
          ...moduleActions,
          addToNewFund: moduleActions.addExchangeToNewFund,
          selectFund: moduleActions.selectExchangeToFund,
        }
      : moduleActions,
    dispatch
  ),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  NewFundContainer
);
